module.exports = __webpack_public_path__ + "img/pic_word_obg.5f4a2586.png";